{ urls } = require 'root/config'

RemindersAPI =
  getList: (scope, successCallback, errorCallback) ->
    $.ajax
      url: urls.admin.reminders.getList
      type: 'GET'
      data: scope
      success: successCallback
      error: errorCallback
      timeout: 5000

  update: (id, attributes, successCallback, errorCallback) ->
    $.ajax
      url: urls.reminders.update(id)
      data: JSON.stringify(attributes)
      contentType: 'application/json'
      type: 'PUT'
      success: successCallback
      error: errorCallback
      timeout: 5000

  destroy: (id, successCallback, errorCallback) ->
    $.ajax
      url: urls.reminders.destroy(id)
      contentType: 'application/json'
      data: JSON.stringify({ id: id })
      type: 'DELETE'
      success: successCallback
      error: errorCallback

module.exports = RemindersAPI
